import React from 'react';
import { Link } from 'react-router-dom';
import VideoBasedCyberThreatsBlogPost from './blog/VideoBasedCyberThreatsBlogPost';

function Blog() {
  return (
    <div className="min-h-screen bg-slate-50">
      <div className="bg-gradient-to-r from-slate-900 to-blue-800 text-white py-14">
        <div className="mx-auto max-w-5xl px-6">
          <p className="text-sm uppercase tracking-[0.2em] text-blue-200">AdverseVideo Blog</p>
          <h1 className="mt-2 text-4xl font-bold">Research and Threat Intelligence</h1>
          <p className="mt-3 max-w-3xl text-slate-200">
            Long-form analysis on adversarial video content, detection patterns, and practical defense strategy.
          </p>
          <div className="mt-6">
            <Link
              to="/"
              className="inline-block rounded-lg bg-white/15 px-4 py-2 text-sm font-semibold hover:bg-white/25"
            >
              Back to Home
            </Link>
          </div>
        </div>
      </div>

      <VideoBasedCyberThreatsBlogPost />
    </div>
  );
}

export default Blog;
